import React, { useRef } from "react";
import TimelinePanels from "./TimelinePanels";
import SecondaryBibliographyData from "./data/secondaryBibliographyData.js";

const panels = [
  "2029 - 2020",
  "2019 - 2010",
  "2009 - 2000",
  "1999 - 1990",
  "1989 - 1980",
  "1979 - 1970",
  "1969 - 1960",
  "1959 - 1950",
  "1949 - 1910",
  "1909 - 1900",
  "1899 - 1796",
];

const SecondaryBibliography = () => {
  const contentRef = useRef(null);

  const getContent = (panel) => {
    if (!contentRef.current) return "";

    const [startYear, endYear] = panel.split(" - ").map(Number);
    const headings = Array.from(contentRef.current.querySelectorAll("h4"));

    let matchedHTML = [];

    headings.forEach((heading) => {
      const year = parseInt(heading.textContent.trim(), 10);
      if (year >= endYear && year <= startYear) {
        const wrapper = document.createElement("div");
        wrapper.className = "timeline-year";
        wrapper.appendChild(heading.cloneNode(true));

        let next = heading.nextElementSibling;
        while (next && next.tagName === "UL") {
          wrapper.appendChild(next.cloneNode(true));
          next = next.nextElementSibling;
        }

        matchedHTML.push(wrapper.outerHTML);
      }
    });

    if (matchedHTML.length) {
      return `<div class="timeline">${matchedHTML.join("")}</div>`;
    }

    return "";
  };

  return (
    <>
      <TimelinePanels panels={panels} getContent={getContent} />
      <div ref={contentRef} style={{ display: "none" }}>
        <SecondaryBibliographyData />
      </div>
    </>
  );
};

export default SecondaryBibliography;
